import React, { useState } from 'react';
import Insights from './Insights';
import config from '../config';
import '../styles.css';

function UploadForm() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [insights, setInsights] = useState(null);
  const [extractedText, setExtractedText] = useState('');
  const [error, setError] = useState('');
  const [progress, setProgress] = useState(0);
  const [loadingStage, setLoadingStage] = useState('');

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setError('');
    setInsights(null);
    setProgress(0);
    setLoadingStage('');
  };

  const simulateProgress = () => {
    setProgress(0);
    setLoadingStage('Uploading file...');
    
    // Simulate upload progress
    setTimeout(() => {
      setProgress(25);
      setLoadingStage('Processing document...');
    }, 500);
    
    setTimeout(() => {
      setProgress(50);
      setLoadingStage('Extracting text...');
    }, 1500);
    
    setTimeout(() => {
      setProgress(75);
      setLoadingStage('Analyzing with Perplexity...');
    }, 3000);

    setTimeout(() => {
      setProgress(88.5);
      setLoadingStage('Getting Report...');
    }, 4500);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) return;

    setLoading(true);
    setError('');
    simulateProgress();

    const formData = new FormData();
    formData.append('labReport', file);

    try {
      const response = await fetch(`${config.API_BASE_URL}/upload`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setProgress(100);
        setLoadingStage('Complete!');
        setTimeout(() => {
          setInsights(data.insights);
          setExtractedText(data.extracted_text);
        }, 500);
      } else {
        setError(data.error || 'Failed to process file');
      }
    } catch (err) {
      setError('Failed to connect to server. Make sure the backend is running.');
    } finally {
      setTimeout(() => {
        setLoading(false);
        setProgress(0);
        setLoadingStage('');
      }, 1000);
    }
  };

  return (
    <div>
      <div className="upload-form">
        <form onSubmit={handleSubmit}>
          <label htmlFor="file-upload">Upload your lab report (PDF only):</label>
          <input
            type="file"
            id="file-upload"
            name="labReport"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleFileChange}
            required
            className="form-control"
          />
          <button 
            type="submit" 
            className={`btn btn-primary mt-3 ${loading ? 'loading' : ''}`}
            disabled={loading || !file}
          >
            {loading ? (
              <div className="button-loading-content">
                <div className="loading-spinner"></div>
                <span>Processing...</span>
              </div>
            ) : (
              'Analyze Report'
            )}
          </button>
        </form>
        
        {loading && (
          <div className="progress-container">
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <div className="progress-text">
              {loadingStage} ({progress}%)
            </div>
          </div>
        )}
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
      </div>

      {insights && (
        <Insights 
          data={insights} 
          extractedText={extractedText}
        />
      )}
    </div>
  );
}

export default UploadForm;